const faqAccordions = document.querySelectorAll(".solstice__faq-right ul li");

function closeAllAccordions() {
  faqAccordions.forEach((accordion) => {
    accordion.classList.remove("open");
    let accordionIcon = accordion.querySelector(".solstice__faq-icon");
    if (accordionIcon) {
      accordionIcon.classList.remove("open");
    }
  });
}

faqAccordions.forEach((accordion) => {
  accordion.addEventListener("click", () => {
    const isAlreadyOpen = accordion.classList.contains("open");
    if (isAlreadyOpen) {
      closeAllAccordions();
      return;
    }
    closeAllAccordions();

    // Open it only if it wasn't already open
    accordion.classList.add("open");
    let accordionIcon = accordion.querySelector(".solstice__faq-icon");
    if (accordionIcon) {
      accordionIcon.classList.add("open");
    }
  });
});
